





































































































































import Vue, { PropType } from "vue"
import PAgeSearchFilter, { AgeModel } from "./searchKit/PAgeSearchFilter.vue"
import PAvailableUptimeSearchFilter from "./searchKit/PAvailableUptimeSearchFilter.vue"
import PJobCategorySearchFilter from "./searchKit/PJobCategorySearchFilter.vue"
import PLastAccessFilter from "./searchKit/PLastAccessFilter.vue"
import PPrefectureSearchFilter from "./searchKit/PPrefectureSearchFilter.vue"
import PWorkingFormSearchFilter from "./searchKit/PWorkingFormSearchFilter.vue"
import BaseSearchModal from "~/components/custom/search/BaseSearchModal.vue"
import TextField from "~/components/guideline/search/TextField.vue"
import FilterList from "~/components/guideline/search/FilterList.vue"
import FilterListItem from "~/components/guideline/search/FilterListItem.vue"
import { SearchParams, makeSearcher } from "~/clStores/profileSearchList"
import {
  JobCategoryOption,
  NormalOption,
  AgeOption,
} from "~/clStores/profileSearchParameterOption"
export { SearchParams } from "~/clStores/profileSearchList"
export {
  JobCategoryOption,
  NormalOption,
  AgeOption,
} from "~/clStores/profileSearchParameterOption"

export interface SearchResult {
  /**
   * 条件にヒットしたプロフィール数
   */
  numberOfTotalHits: number | null
}

type ModalType =
  | "PAgeSearchFilter"
  | "PAvailableUptimeSearchFilter"
  | "PLastAccessFilter"
  | "PJobCategorySearchFilter"
  | "PPrefectureSearchFilter"
  | "PWorkingFormSearchFilter"

interface DataType {
  isShownModalType: ModalType | null
  valueOnForm: SearchParams
  numberOfHits: number | null
}

export default Vue.extend({
  components: {
    TextField,
    FilterList,
    FilterListItem,
    PAgeSearchFilter,
    PAvailableUptimeSearchFilter,
    PLastAccessFilter,
    PJobCategorySearchFilter,
    PPrefectureSearchFilter,
    PWorkingFormSearchFilter,
    BaseSearchModal,
  },
  props: {
    /**
     * 検索パラメータの値
     * v-modelで操作する。
     */
    value: {
      type: Object as PropType<SearchParams>,
      required: true,
    },
    // 認証済みユーザーかどうかの判定フラグ
    isFullParameterSearch: {
      type: Boolean,
      required: true,
    },
    // 職種カテゴリーの選択肢一覧
    jobCategoryOptions: {
      type: Array as PropType<JobCategoryOption[]>,
      required: true,
    },
    availableUptimeOptions: {
      type: Array as PropType<NormalOption[]>,
      required: true,
    },
    sinceLastAccessDaysOptions: {
      type: Array as PropType<NormalOption[]>,
      required: true,
    },
    prefectureOptions: {
      type: Array as PropType<NormalOption[]>,
      required: true,
    },
    workingFormOptions: {
      type: Array as PropType<NormalOption[]>,
      required: true,
    },
    ageOptions: {
      type: Array as PropType<AgeOption[]>,
      required: true,
    },
    hasAnySearchParams: {
      type: Boolean,
      required: true,
    },
    searchResult: {
      type: Object as PropType<SearchResult>,
      default: null,
    },
  },
  data(): DataType {
    return {
      /**
       * 表示する絞り込み用モーダルの種類
       */
      isShownModalType: null,
      /**
       * フォーム上の検索パラメータ。
       * propsで渡されたvalueと同じ形式だが、検索の挙動としては値更新後に「絞り込む」ボタンをクリックすることで更新内容が検索一覧に反映されることになっており、
       * 仮にその前に絞り込みモーダルを閉じた場合は更新した内容は元に戻ることになっている。
       * そのため「絞り込む」ボタンを押される前の一時的な変更はvalueOnFormのみ変更することで再現している。
       */
      valueOnForm: this.value,
      /**
       * 条件にヒットした数
       */
      numberOfHits: null,
    }
  },
  computed: {
    searchResultText(): string {
      const numberOfTotalHits = this.searchResult?.numberOfTotalHits

      if (numberOfTotalHits === 0) {
        return "該当ユーザーがいません"
      }

      if (!this.hasAnySearchParams || !numberOfTotalHits) {
        return ""
      }

      const suffix = !this.isFullParameterSearch ? "（一般公開者のみ）" : ""
      const numberOfHitsText =
        numberOfTotalHits > 1000
          ? "1,000 名以上"
          : `${numberOfTotalHits.toLocaleString()} 名`
      return `${numberOfHitsText}の該当ユーザーがいます${suffix}`
    },
    jobCategoryFieldText() {
      const length = this.value.smallJobCategoryIds.length
      return length ? `職種：${length}` : "職種"
    },
    availableUptimeFieldText() {
      if (this.value.availableUptimeIds.length === 0) {
        return "稼働時間"
      }

      const times = this.value.availableUptimeIds
      return times.length === 1
        ? `週${times[0]}日` // １つのみ選択している場合
        : `週${times[0]}〜${times[times.length - 1]}日` // 複数選択している場合
    },
    lastAccessFieldText() {
      if (!this.value.sinceLastAccessDays) {
        return "最終アクセス"
      }
      return `最終アクセス：${this.value.sinceLastAccessDays}日以内`
    },
    prefectureFieldText() {
      const length = this.value.prefectureIds.length
      return length ? `地域：${length}` : "居住地域"
    },
    workingFormFieldText(): string {
      const workingFormlabel =
        this.workingFormOptions.find(
          (o) => o.value === this.value.workingFormId
        )?.label || null

      return workingFormlabel ? `稼働形態：${workingFormlabel}` : "稼働形態"
    },
    ageFieldText() {
      const minAgeLabel =
        this.ageOptions.find((o) => o.minAgeValue === this.value.minAge)
          ?.minAgeLabel || null
      const maxAgeLabel =
        this.ageOptions.find((o) => o.maxAgeValue === this.value.maxAge)
          ?.maxAgeLabel || null
      return minAgeLabel && maxAgeLabel
        ? `${minAgeLabel}〜${maxAgeLabel}`
        : "年齢"
    },
    /**
     * v-modelを利用してパスされる値。
     * １つの値として渡せるようにvalueOnFormのageに関する値を１つのオブジェクトにして渡して更新された値を受け取れるようにしている。
     */
    ageValue: {
      get(): AgeModel {
        return { min: this.valueOnForm.minAge, max: this.valueOnForm.maxAge }
      },
      set(newAgeValue: AgeModel) {
        this.valueOnForm.minAge = newAgeValue.min
        this.valueOnForm.maxAge = newAgeValue.max
      },
    },
  },
  watch: {
    value() {
      this.valueOnForm = this.value
    },
    valueOnForm: {
      async handler() {
        this.numberOfHits = this.hasAnySearchParams
          ? (await makeSearcher(this.valueOnForm).countTotalHits()).number
          : null
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    changeSearchWord(newVal: string) {
      this.handleInput({
        ...this.value,
        searchWord: newVal,
      })
    },
    openModal(modalType: ModalType, isDisabled: boolean = false) {
      if (isDisabled) {
        this.$emit("click-disabled-filter")
        return
      }
      this.isShownModalType = modalType
    },
    closeModal() {
      this.valueOnForm = this.value // フォーム上の値を検索中のパラメーターで初期化
      this.numberOfHits = null // ヒット数を初期化
      this.isShownModalType = null
    },
    handleInput(arg: SearchParams) {
      this.$emit("input", arg)
    },
    clearJobCategory() {
      this.valueOnForm = {
        ...this.valueOnForm,
        smallJobCategoryIds: [],
      }
      this.handleSearch()
    },
    clearAvailableUptime() {
      this.valueOnForm = {
        ...this.valueOnForm,
        availableUptimeIds: [],
      }
      this.handleSearch()
    },
    clearSinceLastAccessDays() {
      this.valueOnForm = {
        ...this.valueOnForm,
        sinceLastAccessDays: null,
      }
      this.handleSearch()
    },
    clearPrefecture() {
      this.valueOnForm = {
        ...this.valueOnForm,
        prefectureIds: [],
      }
      this.handleSearch()
    },
    clearWorkingForm() {
      this.valueOnForm = {
        ...this.valueOnForm,
        workingFormId: undefined,
      }
      this.handleSearch()
    },
    clearAge() {
      this.valueOnForm = {
        ...this.valueOnForm,
        minAge: null,
        maxAge: null,
      }
      this.handleSearch()
    },
    handleSearch() {
      this.handleInput(this.valueOnForm)
      this.closeModal()
      this.$emit("search")
    },
    handleClickDisabledFilter() {
      this.$emit("click-disabled-filter")
    },
  },
})
